import { userTypeRouting } from "pages/utils";
import Dashboard from "../../dashboard/Dashboard";
import AdminOneDashboard from "../../dashboard/AdminOneDashboard";
import DownloadFileApp from "../../downloadLanding/App";
import { type RouteObject } from "react-router";

declare let viewModel: any;

export const homeRoute: RouteObject = {
  index: true,
  loader: () => viewModel,
  Component: userTypeRouting({
    adminOne: AdminOneDashboard,
    internal: Dashboard,
    external: Dashboard,
  }),
};

export const downloadRoute: RouteObject = {
  path: "/download/:guid",
  loader: () => viewModel,
  Component: DownloadFileApp,
}